import { useContext } from 'react';
import { GridListContext } from './context';
export function useGridList() {
  const context = useContext(GridListContext);
  if (!context) {
    throw new Error('useGridList must be used within a GridList');
  }
  return context;
}